import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSSRPreviewMode } from '../bff-api/customers/useSSRPreviewMode';
import { useShopperContextGet } from '../bff-api/customers/useShopperContextGet';
import {
    PREVIEW_MODE_DATE_PARAM,
    PREVIEW_MODE_PARAM,
    PREVIEW_REFRESH_PATHNAME,
    cleanEffectiveDateTime,
} from '../utils/preview-mode-utils';

export const useActOnPreviewContextChange = (): void => {
    const location = useLocation();
    const isSSRPreviewMode = useSSRPreviewMode();
    const shopperContext = useShopperContextGet();
    const getEffectiveDateTime = useCallback(
        (): string => cleanEffectiveDateTime(shopperContext?.effectiveDateTime as string),
        [shopperContext],
    );
    const effectiveDateTimeTracker = useRef<string>(getEffectiveDateTime());

    useEffect((): void => {
        if (!isSSRPreviewMode || location.pathname === PREVIEW_REFRESH_PATHNAME) {
            return;
        }
        const effectiveDateTime = getEffectiveDateTime();
        if (effectiveDateTimeTracker.current !== effectiveDateTime) {
            effectiveDateTimeTracker.current = effectiveDateTime;
            // refresh the page with a new __preview parameter and __preview_date parameter
            const newUrl = new URL(window.location.href);
            // only set the __preview_date parameter if it is not already set or if it is different from the effectiveDateTime
            if (newUrl.searchParams.get(PREVIEW_MODE_DATE_PARAM) !== effectiveDateTime) {
                newUrl.searchParams.set(PREVIEW_MODE_PARAM, Date.now().toString());
                newUrl.searchParams.set(PREVIEW_MODE_DATE_PARAM, effectiveDateTime);
                window.location.replace(newUrl.toString());
            }
        }
    }, [
        getEffectiveDateTime,
        isSSRPreviewMode,
        location.pathname,
        shopperContext?.effectiveDateTime,
    ]);
};
